const TOGGLE_PLAYERS = '@@headshots/TOGGLE_PLAYERS';
const REQUEST_ZIP = '@@headshots/REQUEST_ZIP';
const ZIP_RESPONSE = '@@headshots/ZIP_RESPONSE';

export default {
    TOGGLE_PLAYERS,
    REQUEST_ZIP,
    ZIP_RESPONSE
};